<script setup>
import {ref, defineEmits, defineModel, nextTick} from "vue";
import StarSvg from "@/components/UI/svg/StarSvg.vue";
import PeopleSvg from "@/components/UI/svg/PeopleSvg.vue";
import LinkSvg from "@/components/UI/svg/LinkSvg.vue";
import RefreshSvg from "@/components/UI/svg/RefreshSvg.vue";
import {GOOGLE_DRIVE_URL} from "@/service/config";
import CrossCloseWindowSvg from "@/components/UI/svg/CrossCloseWindowSvg.vue";

const search = ref("")

const isLoading = defineModel("isLoading");
const isStarred = defineModel("isStarred");
const isShared = defineModel("isShared");

const emits = defineEmits(["updateString", "refresh", 'close-window'])

const timeout = ref(null)

const handleInput = () => {
    // Очистить предыдущий таймер, если он существует
    if (timeout.value !== null) {
        clearTimeout(timeout.value);
    }

    // Установить новый таймер
    timeout.value = setTimeout(() => {
        isLoading.value = true;
        emits("updateString", search.value)
    }, 400);
};

async function toggleStarred() {
    isStarred.value = !isStarred.value
    await nextTick()
    isShared.value = false
    console.log(isStarred.value)
}

async function toggleShared() {
    isShared.value = !isShared.value
    await nextTick()
    isStarred.value = false
}

function goToLink() {
    window.open(GOOGLE_DRIVE_URL)
}

</script>

<template>
    <div class="w-full border-b border-gray-300 flex items-center justify-center flex-col">
        <div class="flex h-1/2 items-center justify-center w-full">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1399.79 1250.67" class="w-10 h-10"><path d="M125.83,1071.89l61.73,106.63c12.82,22.44,31.26,40.08,52.91,52.91L460.94,849.81H20A145.24,145.24,0,0,0,39.24,922Z" transform="translate(-20)" style="fill: rgb(0, 102, 218);"></path><path d="M719.89,400.86,499.42,19.24c-21.64,12.83-40.08,30.47-52.91,52.91L39.24,777.66A145.31,145.31,0,0,0,20,849.81H460.94Z" transform="translate(-20)" style="fill: rgb(0, 172, 71);"></path><path d="M1199.32,1231.43c21.64-12.83,40.08-30.47,52.91-52.91l25.65-44.1L1400.55,922a145.34,145.34,0,0,0,19.24-72.16h-441l93.84,184.4Z" transform="translate(-20)" style="fill: rgb(234, 67, 53);"></path><path d="M719.89,400.86,940.36,19.24C918.72,6.41,893.87,0,868.21,0H571.58c-25.66,0-50.51,7.22-72.16,19.24Z" transform="translate(-20)" style="fill: rgb(0, 131, 45);"></path><path d="M978.85,849.81H460.94L240.47,1231.43c21.65,12.83,46.5,19.24,72.15,19.24h814.54c25.66,0,50.51-7.22,72.16-19.24Z" transform="translate(-20)" style="fill: rgb(38, 132, 252);"></path><path d="M1196.91,424.91,993.28,72.15C980.45,49.71,962,32.07,940.36,19.24L719.89,400.86l259,448.95H1419a145.24,145.24,0,0,0-19.25-72.15Z" transform="translate(-20)" style="fill: rgb(255, 186, 0);"></path></svg>
            <div class="w-4/5 h-12 border border-black rounded-md ml-5 flex items-center justify-center">
                <input v-model="search" @input="handleInput" type="search" placeholder="Искать" class="outline-none w-full h-full mx-5 text-base">
            </div>
        </div>
        <div class="h-8 w-full px-4 flex items-center">
            <div class="lg:hidden" >
                <CrossCloseWindowSvg class="size-8" v-on:click="emits('close-window')" />
            </div>
            <div class="h-full flex items-center ml-auto mr-2 lg:mr-10">
                <div class="flex items-center justify-center mx-1 size-8 rounded-full cursor-pointer transition-all duration-200 hover:bg-gray-200"
                     v-on:click="toggleStarred"
                >
                    <StarSvg class="size-6" :class="{'fill-blue-500': isStarred}" />
                </div>
                <div class="flex items-center justify-center mx-1 size-8 rounded-full cursor-pointer transition-all duration-200 hover:bg-gray-200"
                     v-on:click="toggleShared"
                >
                    <PeopleSvg class="size-6" :class="{'fill-blue-500': isShared}" />
                </div>
                <div class="flex items-center justify-center mx-1 size-8 rounded-full cursor-pointer transition-all duration-200 hover:bg-gray-200"
                     v-on:click="goToLink"
                >
                    <LinkSvg class="size-6" />
                </div>
                <div class="flex items-center justify-center mx-1 size-8 rounded-full cursor-pointer transition-all duration-200 hover:bg-gray-200"
                     v-on:click="emits('refresh')"
                >
                    <RefreshSvg class="size-6" />
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>